import styled, { css } from "styled-components";
import { Colors } from "core/constants";

type ScoreProgressSegmentProps = { width: number; last: boolean; first: boolean };

const getSegmentBorder = ({ last, first }: ScoreProgressSegmentProps) => {
  if (first)
    return css`
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    `;

  if (last)
    return css`
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    `;
};

export const ScoreProgressContainer = styled.div`
  position: relative;
  height: 8px;
  display: flex;
  width: 100%;
`;

export const ScoreProgressSegment = styled.span<ScoreProgressSegmentProps>`
  display: inline-block;
  height: 100%;
  background-color: ${({ theme }) => theme?.colors?.neutral.neutral40};
  width: ${({ width }) => `${width}%`};
  border-right: ${({ last, theme }) =>
    last ? "none" : `2px solid ${theme?.colors?.neutral.neutral50}`};

  ${getSegmentBorder}
`;

export const ScoreProgressBar = styled.div<{ width: number; barColor: string }>`
  height: 100%;
  position: absolute;
  top: 0;
  border-radius: 10px;
  width: ${({ width }) => `${width}%`};
  background-color: ${({ barColor }) => barColor};
`;

export const ScoreProgressPointer = styled.span<{ barColor: string }>`
  line-height: initial;
  height: 24px;
  width: 24px;
  position: absolute;
  right: 0;
  top: -7px;
  border-radius: 50%;
  border: 3px solid ${({ barColor }) => barColor};
  background-color: ${({ theme }) => theme?.colors?.neutral.neutral20};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-family: Nunito-Sans-Bold;
`;
